import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%2C%20dramatic%20romance%20fantasy%20characters%20semi-transparent%20in%20background%2C%20dreamy%20atmospheric%20scene%20with%20floating%20cherry%20blossom%20petals%2C%20deep%20charcoal%20and%20muted%20rose%20tones%2C%20artistic%20abstract%20composition%2C%20soft%20gradient%20with%20dark%20edges%2C%20ethereal%20and%20mysterious%20mood&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫屋 - 海量正版韩国漫画"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            海量正版
          </h1>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            韩国漫画
          </h2>
          <h3 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white/90 leading-tight mb-8" style={{ fontFamily: "var(--font-heading)" }}>
            每日更新
          </h3>
          <Link
            to="/category/romance"
            className="inline-block px-10 py-4 text-lg font-semibold rounded-full bg-emerald-500/90 text-white hover:bg-emerald-500 transition-all whitespace-nowrap cursor-pointer"
          >
            立即阅读
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pb-8 md:pb-12 px-6 md:px-10">
        <p className="text-7xl md:text-9xl lg:text-[12rem] font-extrabold text-white/10 leading-none select-none whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
          韩漫屋
        </p>
      </div>
    </section>
  );
}